import { DeviceHomeAlertData, SoftwareHomeAlertData } from '@zspace/types';
import { useMemo } from 'react';

export function useUserPendingTasks(
  devicesTasks: DeviceHomeAlertData,
  softwareTasks: SoftwareHomeAlertData
) {
  const devicesPendingTasks = useMemo(() => {
    let pendingTasks: string[] = [];

    const pendingDevices = devicesTasks.ungroupedDevicesCount;

    if (pendingDevices) {
      pendingTasks = [`${pendingDevices} ungrouped`];
    }

    return pendingTasks;
  }, [devicesTasks.ungroupedDevicesCount]);

  const softwarePendingTasks = useMemo(() => {
    let pendingTasks: string[] = [];

    if (softwareTasks.unassignedSoftwareCount) {
      pendingTasks = [`${softwareTasks.unassignedSoftwareCount} unassigned`];
    }

    return pendingTasks;
  }, [softwareTasks.unassignedSoftwareCount]);

  return {
    devicesPendingTasks,
    softwarePendingTasks,
  };
}

export default useUserPendingTasks;
